module.exports = __webpack_public_path__ + "static/media/Screen Shot 2020-08-18 at 7.33.37 AM.b5f8ca98.png";